<div kalDialogContent [kalLoading]="isZoneLoading('saveNewPassword')">

    <app-shared-edit-password [formControl]="formControl" />

</div>

<div kalDialogFooter>
    <div class="gup-C-validationArea gup-O-list">
        <div class="gup-O-list__item">
            <kal-button [disabled]="formControl.invalid || loading"
                        kalTheme="primary"
                        (click)="submit()">
                Modifier
            </kal-button>
        </div>
        <div class="gup-O-list__item">
            <kal-button (click)="cancel()"
                        kalTheme="secondary">
                Annuler
            </kal-button>
        </div>
    </div>
</div>
